import { DocumentTypesData } from '@data-access/configurations/types/document.type';
import {
  patchState,
  signalStoreFeature,
  type,
  withMethods,
} from '@ngrx/signals';
import {
  entityConfig,
  setAllEntities,
  withEntities,
} from '@ngrx/signals/entities';

const _documentTypesEntityConfig = () =>
  entityConfig({
    collection: '_documenttypes',
    entity: type<DocumentTypesData>(),
    selectId: (entity) => entity.id,
  });

export const withDocumentTypeEntities = () => {
  return signalStoreFeature(
    withEntities(_documentTypesEntityConfig()),
    withMethods(({ ...store }) => ({
      loadDocumentTypes: (data: DocumentTypesData[]) => {
        return patchState(
          store,
          setAllEntities(data, _documentTypesEntityConfig()),
        );
      },
    })),
  );
};
